// extracted by mini-css-extract-plugin
module.exports = {"modalPromotion":"ReactModalSidebar_modalPromotion__E5RBD"};